/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Unit_MinInputs */



/**
* | output |
* | --- |
* | "min" |
*
* @param {Signup_Compare_Unit_MinInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_unit_min = /** @type {((inputs?: Signup_Compare_Unit_MinInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Unit_MinInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("min")
	if (locale === "de") return /** @type {LocalizedString} */ ("min")
	if (locale === "it") return /** @type {LocalizedString} */ ("min")
	if (locale === "ru") return /** @type {LocalizedString} */ ("min")
	if (locale === "es") return /** @type {LocalizedString} */ ("min")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("min")
	if (locale === "ja") return /** @type {LocalizedString} */ ("min")
	if (locale === "hi") return /** @type {LocalizedString} */ ("min")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("min")
	return /** @type {LocalizedString} */ ("min")
});